import {
  Typography,
  Form,
  Input,
  Button,
  // Row,
  Radio,
  Select,
  InputNumber,
  Row,
  Col,
  Button as ButtonAnt,
  Table,
  TableColumnsType,
  Checkbox,
  SelectProps,
  FormProps,
  Modal,
} from 'antd';
import { css } from '@emotion/react';
import { useModal } from '@/hooks/modal.hook';
import { TargetIndividualModal } from '@/components/modals/nutritional-menu-calculator-management/target-individual.modal';
import { DownloadFileModal } from '@/components/modals/nutritional-menu-calculator-management/download-file.modal';
import { useCallback, useEffect, useState } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { AddDishesModal } from '@/components/modals/nutritional-menu-calculator-management/add-dishes.modal';
import {
  getListDishAge,
  getListDishCookingMethod,
  getListSourceDish,
  getListStructureMealDish,
  getListDishRegion,
} from '@/redux/slices/dish.slice';
import {
  getListGenderComboFood,
  getListPhysicalActivityComboFood,
  getListNutritionHealthStatusComboFood,
  getListNutritionStatusZScoreComboFood,
} from '@/redux/slices/combo-food.slice';

import {
  // getListIngredient,
  // watchListIngredient,
  createNutritionCalculate
} from '@/redux/slices/nutritional-menu-calculator.slice';

import {
  getListFood,
  watchListFood,
} from '@/redux/slices/food.slice';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const { Title } = Typography;

const MEAL_LABEL_MAP: Record<string, string> = {
  BT: 'Bữa tối',
  BTR: 'Bữa trưa',
  BS: 'Bữa sáng',
  BC: 'Bữa chiều',
  BP: 'Bữa phụ'
};

const PRIORITY_OPTIONS = [
  { label: 'Chất bột đường', value: 'GLUCOSE' },
  { label: 'Chất đạm', value: 'PROTEIN' },
  { label: 'Chất béo', value: 'LIPID' },
];

const getFieldNames = (type: string) => {
  return {
    minField: `MIN_${type}_PERCENT`,
    maxField: `MAX_${type}_PERCENT`,
  };
};

const buildMealCodes = (count: number): string[] => {
  switch (count) {
    case 2:
      return ['BTR', 'BT'];
    case 3:
      return ['BS', 'BTR', 'BT'];
    case 4:
      return ['BS', 'BTR', 'BT', 'BP'];
    case 5:
      return ['BS', 'BTR', 'BC', 'BT', 'BP'];
    default:
      return [];
  }
};

type NutritionCalculationProps = {
  setRowTargetProfile: React.Dispatch<React.SetStateAction<TargetProfileListNutritionalMenuCalculator | null>>;
  setValueForm: React.Dispatch<React.SetStateAction<any | null>>;
}
export default function NutritionCalculationTable({ setRowTargetProfile, setValueForm }: NutritionCalculationProps) {
  const [form] = Form.useForm();
  const { openModal, closeModal } = useModal();
  const [open, setOpen] = useState(false);
  const listIngredient = useAppSelector(watchListFood);
  const [selectedRowTargetProfile, setSelectedRowTargetProfile] = useState<TargetProfileListNutritionalMenuCalculator | null>(null);

  const [selectedRowDishes, setSelectedRowDishes] = useState<Dish[]>([]);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [mealOptions, setMealOptions] = useState<SelectProps['options']>([]);
  const [priorityCount, setPriorityCount] = useState<number>(0);
  const dispatch = useAppDispatch();

  const listIngredientOptions = listIngredient.map((item) => ({
    value: String(item.ID),
    label: item.NAME
  }));

  console.log('selectedRowDishes', selectedRowDishes);
  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getListDishAge());
    dispatch(getListDishCookingMethod());
    dispatch(getListSourceDish());
    dispatch(getListStructureMealDish());
    dispatch(getListDishRegion());
    dispatch(getListGenderComboFood());
    dispatch(getListPhysicalActivityComboFood());
    dispatch(getListNutritionHealthStatusComboFood());
    dispatch(getListNutritionStatusZScoreComboFood());
  }, [dispatch]);

  const handlePriorityChange = (e: any) => {
    const val = e.target.value;
    if (val === '1') setPriorityCount(1);
    else if (val === '2') setPriorityCount(2);
    else setPriorityCount(0);
    form.setFieldsValue({ priorities: [] });
  };



  const handleViewInformation = () => {
    // openModal(
    //   <TargetIndividualModal
    //     onCancel={closeModal}
    //     setSelectedRow={setSelectedRowTargetProfile}
    //   />, { width: 1200 }
    // );
    showModal();
  };

  const handleDownloadFile = () => {
    openModal(
      <DownloadFileModal
        onCancel={closeModal}
      />, { width: 500 }
    );
  };

  useEffect(() => {
    if (selectedRowTargetProfile) {
      const count = selectedRowTargetProfile.DAY_MEALS.length;
      const codes = buildMealCodes(count);
      const opts = codes.map((m) => ({
        label: MEAL_LABEL_MAP[m] || m,
        value: m,
      }));
      setMealOptions(opts);

      const defaultMeal = codes.includes('BTR') ? 'BTR' : codes[0];

      form.setFieldsValue({
        object: selectedRowTargetProfile.AGE_RANGE_DESCRIPTION,
        healthCondition: selectedRowTargetProfile.HEALTH_STATUS_NAME,
        meal: selectedRowTargetProfile.DAY_MEALS.length,
        calculatedMeal: defaultMeal,
        kcalMin: selectedRowTargetProfile.PROFILE_WEIGHT_MIN,
        kcalMax: selectedRowTargetProfile.PROFILE_WEIGHT_MAX
      });
    }
  }, [form, selectedRowTargetProfile]);

  const handleMealChange = (value: number) => {
    const codes = buildMealCodes(value);
    const opts = codes.map((m) => ({ label: MEAL_LABEL_MAP[m] || m, value: m }));
    setMealOptions(opts);

    const newDefault = codes.includes('BTR') ? 'BTR' : codes[0];
    form.setFieldsValue({ calculatedMeal: newDefault });
  };

  const handleAddDishes = () => {
    openModal(
      <AddDishesModal
        onCancel={closeModal}
        setSetSelectedRow={setSelectedRowDishes}
      />, { width: 1400 }
    );
  };

  const handleAddEmptyRow = () => {
    const currentData = form.getFieldValue('data') || [];
    const newKey = `new_${Date.now()}`;
    const newRow = {
      key: newKey,
      FOOD_NAME: '',
      INGREDIENT: '',
      MIN_WEIGHT: null,
      MAX_WEIGHT: null,
      MIN_LIMIT: null,
      MAX_LIMIT: null,
      fixed: false,
    };
    const updated = [...currentData, newRow];
    setDataSource(updated);
    form.setFieldsValue({ data: updated });
  };

  const handleDelete = (key: string) => {
    const currentData = form.getFieldValue('data') || [];
    const updated = currentData.filter((item: any) => item.key !== key);
    setDataSource(updated);
    form.setFieldsValue({ data: updated });
  };

  const toCamelCase = (str: string) => {
    return str.toLowerCase().replace(/_([a-z])/g, (_, group) => group.toUpperCase());
  };

  const convertKeysToCamelCase = useCallback(
    (obj: Record<string, any>) => {
      const newObj: Record<string, any> = {};
      for (const key in obj) {
        const newKey = toCamelCase(key);
        newObj[newKey] = obj[key];
      }
      return newObj;
    },
    []
  );


  useEffect(() => {
    if (selectedRowDishes?.length) {
      const currentData = form.getFieldValue('data') || [];

      const newData = selectedRowDishes.flatMap((dish) => {
        const camelCaseDish = convertKeysToCamelCase(dish);

        if (!Array.isArray(camelCaseDish.ingredients) || camelCaseDish.ingredients.length === 0) {
          return [
            {
              FOOD_NAME: camelCaseDish.name,
              INGREDIENT: {
                id: '',
                name: ''
              },
              MIN_WEIGHT: undefined,
              MAX_WEIGHT: undefined,
              MIN_LIMIT: undefined,
              MAX_LIMIT: undefined,
              fixed: false,
              key: `${dish.id}_${Date.now()}_${Math.random()}`
            }
          ];
        }

        return camelCaseDish.ingredients.map((ing: any) => (
          {
            FOOD_NAME: camelCaseDish.name,
            // INGREDIENT: {
            //   value: ing.INGREDIENT_ID,
            //   label: ing.INGREDIENT_NAME
            // },
            INGREDIENT: ing.INGREDIENT_ID,
            MIN_WEIGHT: ing.WEIGHT ?? undefined,
            MAX_WEIGHT: undefined,
            MIN_LIMIT: undefined,
            MAX_LIMIT: undefined,
            fixed: false,
            key: `${camelCaseDish.dishId}_${ing.ingredientId}_${Date.now()}_${Math.random()}`
          }));
      });


      console.log('newdata', newData);
      const mergedData = [...currentData, ...newData];
      setDataSource(mergedData);
      form.setFieldsValue({ data: mergedData });
    }
  }, [form, selectedRowDishes, convertKeysToCamelCase]);

  useEffect(() => {
    dispatch(getListFood());
  }, [dispatch]);


  const onFinish: FormProps<any>['onFinish'] = async (
    values
  ) => {
    const data = values.data;
    const buildMealLgp = (
      priorities: {
        type: 'GLUCOSE' | 'PROTEIN' | 'LIPID';
        [k: string]: any;
      }[] = [],
    ): MealLGPCalculateNutrition => {
      const lgp: MealLGPCalculateNutrition = {
        MAX_LIPID_PERCENT: 0,
        MIN_LIPID_PERCENT: 0,
        MAX_GLUCOSE_PERCENT: 0,
        MIN_GLUCOSE_PERCENT: 0,
        MAX_PROTEIN_PERCENT: 0,
        MIN_PROTEIN_PERCENT: 0,
      };

      priorities.forEach((p) => {
        if (!p?.type) return;
        switch (p.type) {
          case 'GLUCOSE':
            lgp.MIN_GLUCOSE_PERCENT = Number(p.MIN_GLUCOSE_PERCENT ?? 0);
            lgp.MAX_GLUCOSE_PERCENT = Number(p.MAX_GLUCOSE_PERCENT ?? 0);
            break;
          case 'PROTEIN':
            lgp.MIN_PROTEIN_PERCENT = Number(p.MIN_PROTEIN_PERCENT ?? 0);
            lgp.MAX_PROTEIN_PERCENT = Number(p.MAX_PROTEIN_PERCENT ?? 0);
            break;
          case 'LIPID':
            lgp.MIN_LIPID_PERCENT = Number(p.MIN_LIPID_PERCENT ?? 0);
            lgp.MAX_LIPID_PERCENT = Number(p.MAX_LIPID_PERCENT ?? 0);
            break;
        }
      });
      return lgp;
    };

    const ingredients = (data as IngredientCalculateNutrition[])
      .filter(r => r.INGREDIENT)
      .map(r => {
        const info = listIngredient.find(
          i => i.ID === r.INGREDIENT,
        ) as IngredientNutritionalMenuCalculator | undefined;

        return {
          INGREDIENT: info?.INGREDIENT_NAME ?? r.INGREDIENT,
          FOOD_NAME: r.FOOD_NAME ?? '',
          MIN_WEIGHT: Number(r.MIN_WEIGHT ?? 0),
          MAX_WEIGHT: Number(r.MAX_WEIGHT ?? 0),
          MIN_LIMIT: Number(r.MIN_LIMIT ?? 0),
          MAX_LIMIT: Number(r.MAX_LIMIT ?? 0),
          INGREDIENT_INFO: {
            STANDARD_VOLUME: Number(info?.WEIGHT ?? 0),
            INGREDIENT_NAME: info?.INGREDIENT_NAME ?? '',
            ENERGY: Number(info?.ENERGY ?? 0),
            FAT: Number(info?.FAT ?? 0),
            STARCH_SUGAR: Number(info?.CARBOHYDRATE ?? 0),
            PROTEIN: Number(info?.PROTEIN ?? 0),
          },
        };
      });
    const lgp = buildMealLgp(values.priorities);
    const payload: CalculateNutrition = {
      INPUT: {
        ETA: values.eta,
        GAMMA: values.gamma,
        MIN_KCAL: values.kcalMin,
        MAX_KCAL: values.kcalMax,
        MEAL_LGP: lgp,
      },
      INGREDIENTS: ingredients,
    };
    setRowTargetProfile(selectedRowTargetProfile);
    setValueForm(values);
    await dispatch(createNutritionCalculate(payload));
  };

  const columns: TableColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'index',
      width: 10,
      align: 'center',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Tên món ăn',
      dataIndex: 'FOOD_NAME',
      align: 'center',
      render: (_: any, record: any, index: number) => (
        <Form.Item name={['data', index, 'FOOD_NAME']} style={{ margin: 0 }}>
          <div
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              padding: 0,
              width: 100,
              textAlign: 'left',
            }}
          >
            {record.FOOD_NAME}
          </div>
        </Form.Item>
      ),
      width: 100
    },
    {
      title: 'Tên nguyên liệu',
      dataIndex: 'INGREDIENT',
      align: 'center',
      render: (_: any, __: any, index: number) => (
        <Form.Item
          name={['data', index, 'INGREDIENT']}
          rules={[{ required: true, message: 'Chọn nguyên liệu' }]}
          style={{ margin: 0 }}
        >
          <Select
            options={listIngredientOptions}
            // options={listIngredient.map((item) => ({
            //   value: item.ID,
            //   label: item.NAME
            // }))}
            style={{ width: 100 }}
          />
        </Form.Item>
      ),
      width: 100
    },
    {
      title: 'Khối lượng khởi tạo (g)',
      children: [
        {
          title: 'Min',
          dataIndex: 'MIN_WEIGHT',
          align: 'center',
          render: (_: any, __: any, index: number) => (
            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
              <Form.Item
                name={['data', index, 'MIN_WEIGHT']}
                style={{ margin: 0 }}
                rules={[{ required: true, message: 'Vui lòng nhập' }]}
              >
                <InputNumber
                  min={0}
                  type="number"
                  style={{ width: 50 }}
                />
              </Form.Item>
            </div>
          ),
        },
        {
          title: 'Max',
          dataIndex: 'MAX_WEIGHT',
          align: 'center',
          render: (_: any, __: any, index: number) => (
            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
            >
              <Form.Item
                name={['data', index, 'MAX_WEIGHT']}
                style={{ margin: 0 }}
                rules={[{ required: true, message: 'Vui lòng nhập' }]}
              >
                <InputNumber
                  min={0}
                  type="number"
                  style={{ width: 50 }}
                />
              </Form.Item>
            </div>
          ),
        },
      ],
      width: 50
    },
    {
      title: 'Giới hạn dưới & trên (%)',
      children: [
        {
          title: 'Min',
          dataIndex: 'MIN_LIMIT',
          align: 'center',
          render: (_: any, __: any, index: number) => (
            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
              <Form.Item
                name={['data', index, 'MIN_LIMIT']}
                style={{ margin: 0 }}
                rules={[{ required: true, message: 'Vui lòng nhập' }]}
              >
                <InputNumber
                  min={0}
                  type="number"
                  style={{ width: 50 }}
                />
              </Form.Item>
            </div>
          ),
        },
        {
          title: 'Max',
          dataIndex: 'MAX_LIMIT',
          align: 'center',
          render: (_: any, __: any, index: number) => (
            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
              <Form.Item
                name={['data', index, 'MAX_LIMIT']}
                rules={[{ required: true, message: 'Vui lòng nhập' }]}
                style={{ margin: 0, textAlign: "center" }}
              >
                <InputNumber
                  min={0}
                  type="number"
                  style={{
                    width: 50,
                  }}
                />
              </Form.Item>
            </div>
          ),
        },
      ],
    },
    {
      title: 'Cố định kết quả',
      dataIndex: 'fixed',
      align: 'center',
      render: (_: any, __: any, index: number) => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <Form.Item
            name={['data', index, 'fixed']}
            valuePropName="checked"
            style={{ margin: 0 }}
          >
            <Checkbox />
          </Form.Item>
        </div>
      ),
    },
    {
      title: 'Thao tác',
      align: 'center',
      render: (_: any, record: any) => (
        <ButtonAnt
          danger
          type='primary'
          icon={<DeleteOutlined />}
          onClick={() => handleDelete(record.key)}
        />
      ),
    },
  ];

  return (

    <>
      <Modal
        open={open}
        onCancel={handleCancel}
        footer={null}
        width={1500}
      >
        <TargetIndividualModal
          onCancel={handleCancel}
          setSelectedRow={setSelectedRowTargetProfile}
          selectedRow={selectedRowTargetProfile}
        />
      </Modal>
      <div css={rootStyles}>
        <div css={boxStyles}>
          <Form
            form={form}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            onFinish={onFinish}
            requiredMark={false}
          >
            <Title level={5}>Nhập điều kiện tính toán</Title>

            <Form.Item
              label={
                <span>
                  Eta<span style={{ color: 'red', marginLeft: 2 }}>*</span>
                </span>
              }
              name="eta"
              rules={[{ required: true }]}
              initialValue={0.001}
            >
              <InputNumber
                min={0}
                step={0.1}
                stringMode
                decimalSeparator="."
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  Gamma<span style={{ color: 'red', marginLeft: 2 }}>*</span>
                </span>
              }
              name="gamma"
              rules={[{ required: true }]}
              initialValue={0.98}
            >
              <InputNumber
                min={0}
                step={0.1}
                stringMode
                decimalSeparator="."
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              label={
                <strong style={{ fontWeight: 600 }}>
                  Đối tượng xây dựng thực đơn
                </strong>
              }
            >
              <Button type="primary" style={{ backgroundColor: '#FBC02D', border: 'none' }}
                onClick={() => handleViewInformation()}>
                Chọn đối tượng tính toán
              </Button>
            </Form.Item>
            {selectedRowTargetProfile && (
              <>
                <Form.Item label="Đối tượng đã chọn">
                  <div style={{ display: 'flex', gap: 8, width: '100%' }}>
                    <Form.Item name="object" noStyle rules={[{ required: true }]}>
                      <Input style={{ flex: 1 }} />
                    </Form.Item>
                    <ButtonAnt
                      type="primary"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => {
                        form.setFieldsValue({ object: undefined });
                        setSelectedRowTargetProfile(null);
                      }}
                    />
                  </div>
                </Form.Item>
                <Form.Item
                  label={<span css={css``}>Tình trạng bệnh lý</span>}
                  name="healthCondition"
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label={<span css={css``}>Số bửa ăn/ngày</span>}
                  name="meal"
                >
                  <Select
                    options={[
                      { label: '2', value: 2 },
                      { label: '3', value: 3 },
                      { label: '4', value: 4 },
                      { label: '5', value: 5 },
                    ]}
                    onChange={handleMealChange}
                  />
                </Form.Item>
                <Form.Item
                  label={<span css={css``}>Bửa ăn cần tính toán</span>}
                  name="calculatedMeal"
                >
                  <Select
                    options={mealOptions}
                  />
                </Form.Item>
              </>
            )}

            <Form.Item
              label={
                <span>
                  Tổng Kcal mục tiêu<span style={{ color: 'red', marginLeft: 2 }}>*</span>
                </span>
              }
              rules={[{ required: true }]}>
              <Form.Item name="kcalMin" noStyle rules={[{ required: true }]} >
                <InputNumber placeholder="Từ" suffix="Kcal" style={{ marginRight: '0.2rem' }} />
              </Form.Item>
              <Form.Item name="kcalMax" noStyle rules={[{ required: true }]} >
                <InputNumber placeholder="Đến" suffix="Kcal" style={{ marginLeft: '0.2rem' }} />
              </Form.Item>
            </Form.Item>

            <Form.Item name="priority" className="radioStyle">
              <Radio.Group onChange={handlePriorityChange}>
                <Radio value="1">Ưu tiên 1 chất</Radio>
                <Radio value="2">Ưu tiên 2 chất</Radio>
                <Radio value="none">Không ưu tiên chất nào</Radio>
              </Radio.Group>
            </Form.Item>

            {priorityCount > 0 && (
              <>
                <div className="labelStyle">
                  <label>Chọn chất ưu tiên và nhập tỉ lệ % PLG phân bổ theo bữa</label>
                </div>

                {[...Array(priorityCount)].map((_, index) => (
                  <Form.Item
                    key={index}
                    style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                  >
                    <Form.Item
                      name={['priorities', index, 'type']}
                      style={{ width: '30%' }}
                      rules={[{ required: true, message: 'Chọn chất' }]}
                    >
                      <Select
                        placeholder="Chọn chất ưu tiên"
                        options={PRIORITY_OPTIONS}
                      />
                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) =>
                        prev.priorities?.[index]?.type !== curr.priorities?.[index]?.type
                      }
                    >
                      {({ getFieldValue }) => {
                        const type = getFieldValue(['priorities', index, 'type']);
                        const { minField } = getFieldNames(type || '');
                        return (
                          <Form.Item
                            name={['priorities', index, minField]}
                            style={{ width: '33%' }}
                            rules={[{ required: true, message: 'Nhập min' }]}
                          >
                            <Input placeholder="Từ" type="number" />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) =>
                        prev.priorities?.[index]?.type !== curr.priorities?.[index]?.type
                      }
                    >
                      {({ getFieldValue }) => {
                        const type = getFieldValue(['priorities', index, 'type']);
                        const { maxField } = getFieldNames(type || '');
                        return (
                          <Form.Item
                            name={['priorities', index, maxField]}
                            style={{ width: '33%' }}
                            rules={[{ required: true, message: 'Nhập max' }]}
                          >
                            <Input placeholder="Đến" type="number" suffix="%" />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </Form.Item>
                ))}
              </>
            )}

            <Title level={5}>Nhập điều kiện tính toán</Title>
            <Row css={boxStyles} justify="space-between" align="middle">
              <Col>
                <Button
                  iconPosition="start"
                  css={downloadFileButtonStyles}
                  onClick={() => handleDownloadFile()}
                >
                  Nhập nguyên liệu theo file
                </Button>
              </Col>

              <Col>
                <Row justify="space-between" css={{ gap: '10px' }}>
                  <Button
                    iconPosition="start"
                    css={selfInputButtonStyles}
                  >
                    Tải file Tiêu chuẩn định lượng thực phẩm tham khảo
                  </Button>
                </Row>
              </Col>
              <div css={tableStyle}>
                <Table<any>
                  rowKey="key"
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false}
                  size='small'
                />
              </div>
              <div css={rowButtonStyle}>
                <Button
                  onClick={handleAddEmptyRow}
                  css={buttonStyle}
                  type='dashed'
                >
                  <PlusOutlined /> Thêm thực phẩm
                </Button>
              </div>
            </Row>
            <div css={rowButtonStyle}>
              <Button css={buttonStyle}
                type='dashed'
                onClick={handleAddDishes}
              >
                <PlusOutlined />Thêm món ăn
              </Button>
            </div>
            <div css={rowSubmitButtonStyle}>
              <Button css={submitButtonStyle}
                htmlType='submit'
              >
                Tính định lượng
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const boxStyles = css`
  background: var(--white-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }

  .ant-table-thead > tr > th {
    background: var(--blue-dark-color) !important;
    color: var(--white-color);
  }

  .ant-table-cell::before {
    display: none;
  }

  .ant-form-item-label {
    label {
        width: 100%;
    }
  }
  .ant-input-number-affix-wrapper {
    width: 100% !important;
  }

  .ant-col-16 {
    max-width: 100%;
  }

  .ant-form-item-row {
     width: 100%;
  }

  .ant-form-item-control-input {
    width: 100%;
  }

  .ant-form-item-control-input-content {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .radioStyle {
    margin-bottom: 1rem;
  }

  .labelStyle {
    margin-bottom: 1rem;
  }
`;

const downloadFileButtonStyles = css`
  background-color: var(--success-color);
  color: var(--white-color);
  border-color: var(--success-color);

  &:hover {
    background-color: var(--success-color) !important;
    border-color: var(--success-color) !important;
  }
`;

const selfInputButtonStyles = css`
  &:hover {
    background-color: var(--white-color) !important;
    color: var(--blue-light-color) !important;
    border-color: var(--blue-light-color) !important;
  }
`;

const rowSubmitButtonStyle = css`
  display: flex;
  justify-content: end;
`

const submitButtonStyle = css`
    background-color: var(--blue-light-color);
    color: var(--white-color);
    border-color: var(--blue-light-color);

    &:hover {
        color: var(--white-color) !important;
        background-color: var(--blue-light-color) !important;
        border-color: var(--blue-light-color) !important;
    }
`

const rowButtonStyle = css`
  margin-top: 1rem;
  display: flex;
  justify-content: start;
`

const buttonStyle = css`
    color: var(--blue-light-color);
    border-color: var(--blue-light-color);

    &:hover {
        color: var(--white-color) !important;
        background-color: var(--blue-light-color) !important;
        border-color: var(--blue-light-color) !important;
    }
`

const tableStyle = css`
  margin-top: 1rem;
  .ant-form-item-control-input-content {
    display: flex;
    justify-content: center;
    align-item: center;
  }
    
`